import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { JournalVersionTitlePage } from "../journals-title/ui/journal-version-title";

export const JournalsVersionRoute = (): RouteObject => {
  return {
    path: `${routes.journals.version()}:journalVersionId?/`,
    element: createElement(JournalVersionTitlePage),
  };
};
